import { exactVariablePattern } from '../constants';
export function sortUrlMappingsSegments(firstMapping, secondMapping) {
    return getSegmentsWeight(secondMapping) - getSegmentsWeight(firstMapping);
}
var getSegmentsWeight = function (mapping) {
    var segments = mapping.split('/');
    return segments.reduce(function (totalWeight, currentSegment, index) {
        var isVariable = exactVariablePattern.test(currentSegment);
        var segmentWeight = isVariable
            ? 0
            : Math.pow(10, segments.length - index);
        return totalWeight + segmentWeight;
    }, 0);
};
//# sourceMappingURL=sort-url-mappings-segments.js.map